(function () {
  var TIERS = [
    { min: 5,  discount: 5  },
    { min: 10, discount: 10 },
    { min: 20, discount: 15 }
  ];

  function getNextTier(totalQty) {
    for (var i = 0; i < TIERS.length; i++) {
      if (totalQty < TIERS[i].min) return TIERS[i];
    }
    return null;
  }

  function getProgress(totalQty) {
    if (totalQty < 5)  return Math.min(totalQty / 5 * 100, 100);
    if (totalQty < 10) return Math.min((totalQty - 5) / 5 * 100, 100);
    if (totalQty < 20) return Math.min((totalQty - 10) / 10 * 100, 100);
    return 100;
  }

  function renderTierBar(totalQty) {
    var bar = document.querySelector('[data-cart-tier-bar]');
    if (!bar) return;

    var nextTier = getNextTier(totalQty);

    if (!nextTier) {
      bar.innerHTML =
        '<p class="cart-tier-bar__message cart-tier-bar__message--reached">' +
        'Félicitations ! Vous bénéficiez de la meilleure réduction : <strong>-15%</strong>' +
        '</p>';
      return;
    }

    var needed = nextTier.min - totalQty;
    var progress = getProgress(totalQty);
    var plural = needed > 1 ? 's' : '';

    bar.innerHTML =
      '<p class="cart-tier-bar__message">' +
      'Ajoutez <strong>' + needed + ' article' + plural + ' de plus</strong>' +
      ' pour débloquer <strong>-' + nextTier.discount + '%</strong>' +
      ' à partir de ' + nextTier.min + ' articles' +
      '</p>' +
      '<div class="cart-tier-bar__track">' +
      '<div class="cart-tier-bar__fill" style="--progress: ' + progress + '%"></div>' +
      '</div>';
  }

  function getTotalQty(cartData) {
    var total = 0;
    if (cartData && cartData.items) {
      for (var i = 0; i < cartData.items.length; i++) {
        total += cartData.items[i].quantity;
      }
    }
    return total;
  }

  // empire.js dispatches this after every cart quantity change
  window.addEventListener('cartcount:update', function (e) {
    renderTierBar(getTotalQty(e.detail));
  });

  // Collection filter dropdown (toggled next to "Trier par")
  function closeFilterDropdown(wrapper) {
    var trigger = wrapper.querySelector('[data-productgrid-filter-dropdown-trigger]');
    var panel = wrapper.querySelector('[data-productgrid-filter-dropdown]');
    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  }

  function openFilterDropdown(wrapper) {
    var trigger = wrapper.querySelector('[data-productgrid-filter-dropdown-trigger]');
    var panel = wrapper.querySelector('[data-productgrid-filter-dropdown]');
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');

    if (!panel.dataset.expanded) {
      panel.dataset.expanded = 'true';
      requestAnimationFrame(function () {
        panel.querySelectorAll('[data-filter-group-trigger][aria-expanded="false"]').forEach(function (groupTrigger) {
          groupTrigger.click();
        });
      });
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-productgrid-filter-dropdown-trigger]');
    var wrappers = document.querySelectorAll('[data-productgrid-filter-dropdown-wrapper]');

    if (trigger) {
      var wrapper = trigger.closest('[data-productgrid-filter-dropdown-wrapper]');
      var isOpen = wrapper.querySelector('[data-productgrid-filter-dropdown-trigger]').getAttribute('aria-expanded') === 'true';

      wrappers.forEach(function (w) {
        closeFilterDropdown(w);
      });

      if (!isOpen) {
        openFilterDropdown(wrapper);
      }
      return;
    }

    if (!e.target.closest('[data-productgrid-filter-dropdown]')) {
      wrappers.forEach(function (w) {
        closeFilterDropdown(w);
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-productgrid-filter-dropdown-wrapper]').forEach(function (w) {
      closeFilterDropdown(w);
    });
  });

  // Save the cart note while it is typed, so express checkout buttons (Shop Pay, PayPal...) keep it
  var cartNote = document.getElementById('cart-note');
  if (cartNote) {
    var cartNoteTimer = null;

    function saveCartNote() {
      clearTimeout(cartNoteTimer);
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: cartNote.value })
      });
    }

    cartNote.addEventListener('input', function () {
      clearTimeout(cartNoteTimer);
      cartNoteTimer = setTimeout(saveCartNote, 400);
    });
    cartNote.addEventListener('change', saveCartNote);
  }
})();

// Fiche produit mobile (< 720 px) : le bloc quantite + "Ajouter au panier" s'affiche sous le prix,
// a sa place, quand il est entierement visible ; sinon il reste fixe en bas de l'ecran (comme avant).
// Exception : s'il cachait le prix en etant fixe (petits ecrans, haut de page), il reste a sa place.
// La classe lbdj-atc-inline (pango-custom.css) annule le position: fixed. 2026-10-01
(function () {
  var mq = window.matchMedia('(max-width: 719px)');
  var wrapper = null;
  var slot = null;
  var ticking = false;

  function setup() {
    if (!document.body.classList.contains('template-product')) return false;
    var w = document.querySelector('.product--outer .product-form--atc .product-form__action-wrapper');
    if (!w) return false;
    if (w !== wrapper) {
      wrapper = w;
      // Garde la place du bloc quand il est fixe, pour que la page ne saute pas
      slot = document.createElement('div');
      slot.className = 'lbdj-atc-slot';
      w.parentNode.insertBefore(slot, w);
    }
    return true;
  }

  function update() {
    ticking = false;
    if (!setup()) return;
    if (!mq.matches) {
      wrapper.classList.remove('lbdj-atc-inline');
      slot.style.height = '';
      return;
    }
    var inline = wrapper.classList.contains('lbdj-atc-inline');
    var marge = parseFloat(getComputedStyle(wrapper).marginTop) || 0;
    var haut = inline ? wrapper.getBoundingClientRect().top : slot.getBoundingClientRect().top + marge;
    var h = wrapper.offsetHeight;
    var bas = window.innerHeight;
    var entier = haut >= 0 && haut + h <= bas;
    // Fixe, il occupe [bas - 5 - h, bas - 5] (bottom: 5px dans pango-custom.css)
    var prix = document.querySelector('.product--outer .product-block--price');
    var p = prix && prix.getBoundingClientRect();
    var cacheLePrix = !!p && haut >= 0 && p.top < bas - 5 && p.bottom > bas - 5 - h;
    var aSaPlace = entier || cacheLePrix;
    if (aSaPlace && !inline) {
      slot.style.height = '';
      wrapper.classList.add('lbdj-atc-inline');
    } else if (!aSaPlace && inline) {
      slot.style.height = (h + marge) + 'px';
      wrapper.classList.remove('lbdj-atc-inline');
    }
  }

  function demande() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', demande, { passive: true });
  window.addEventListener('resize', demande);
  window.addEventListener('load', demande);
  if (mq.addEventListener) mq.addEventListener('change', demande);
  if (window.ResizeObserver) {
    var fiche = document.querySelector('.product--outer');
    if (fiche) new ResizeObserver(demande).observe(fiche);
  }
  demande();
})();
